import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { VistoriaApiService } from '../../realizar-vistoria/services/vistoria-api.service';
import { MessageService } from '@services/message.service';
import { Permissao } from '@models/enums/permissao';
import { ModeloVistoriaListItem } from '../../editar-modelo-vistoria/models/modelo-vistoria-list-item';
import { VistoriaListItem } from '../models/vistoria-list-item';
import { SituacaoVistoria, SituacaoVistoriaNomeMap } from '../../realizar-vistoria/models/vistoria';

@Component({
  selector: 'app-listar-vistorias',
  standalone: false,
  templateUrl: './listar-vistorias.component.html',
  styleUrl: './listar-vistorias.component.scss'
})
export class ListarVistoriasComponent implements OnInit {

  @ViewChild('dt') table!: Table;

  protected get permissaoRealizarVistoria() { return Permissao.REALIZAR_VISTORIA; }

  vistorias: VistoriaListItem[] = [];
  modelos: ModeloVistoriaListItem[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private vistoriaApiService: VistoriaApiService,
    private messageService: MessageService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      this.modelos = data['modelos'] as ModeloVistoriaListItem[];
      this.vistorias = data['vistorias'] as VistoriaListItem[];
    });
  }

  public editarClick(vistoria: VistoriaListItem): void {
    this.router.navigate(['/vistoria/realizar', vistoria.id]);
  }

  public removerClick(vistoria: VistoriaListItem): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Remover vistoria';
    dialogRef.componentInstance.mensagem = `A vistoria de "${vistoria.endereco}" será removida.`;
    dialogRef.componentInstance.textoBtnConfirmacao = 'Remover';
    dialogRef.componentInstance.btnBackgroundColor = '#F44336';
    dialogRef.componentInstance.acaoConfirmacao = () => this.remover(vistoria);
  }

  private remover(vistoria: VistoriaListItem): void {
    this.vistoriaApiService.deletar(vistoria.id).subscribe(() => {
      this.messageService.showToastSuccess('Vistoria removida com sucesso');
      this.vistorias = this.vistorias.filter(v => v.id !== vistoria.id);
    });
  }

  public nomeSituacao(situacao: SituacaoVistoria): string {
    return SituacaoVistoriaNomeMap.get(situacao) ?? '';
  }

  public selecionarModeloClick(modelo: ModeloVistoriaListItem | null): void {
    if (!modelo) return;
    this.router.navigate(['/vistoria/realizar'], { queryParams: { modeloId: modelo.id } });
  }

  public iniciarSemModeloClick(): void {
    this.router.navigate(['/vistoria/realizar']);
  }

  public filtrar(valor: string): void {
    this.table.filterGlobal(valor, 'contains');
  }
}
